module.exports = __webpack_public_path__ + "img/10.03bafa12.png";